<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   


	<div class="backborder1" v-loading="walletloading" style="padding-bottom:10px;display:inline-block;">

		<!--  具体提现数据  -->
		<div class="sys-wallet-msg-center" style="float:left;display:flex;justify-content:left;width:calc(86% - 40px - 1px);height:80px;align-items:center;padding:0 20px 0 20px;border-right:1px solid #EBEEF5;">
			<div class="sys-wallet-msg-center-ul" style="float;width:100%">

				<!-- 普通提现金额 -->
				<div class="sys-wallet-msg-center-li" style="float:left;width:100%;height:40px;border-bottom:1px solid #EBEEF5;overflow:hidden;">

					<!-- 保障金 -->
					<el-tooltip class="item" effect="dark" content="已完成并提现的订单发起售后退款的金额" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:calc(40px - 1px);display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							预扣保障金（普通）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.normal_refundprices}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.normal_refundordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>

					<!-- 冻结提现金额 -->
					<el-tooltip class="item" effect="dark" content="已支付但订单状态未达到已完成状态的订单（商家已取消的订单除外），该金额不含服务费" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:calc(40px - 1px);display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							冻结提现金额（普通）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.normal_realfrozenmoney}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.normal_frozenordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>

					<!-- 正在提现金额 -->
					<el-tooltip class="item" effect="dark" content="已提交提现申请，但平台尚未进行提现审核的订单，该金额不含手续费" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:calc(40px - 1px);display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							正在提现金额（普通）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.normal_realwaitingmoney}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.normal_waitingordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>

					<!-- 可提现金额 -->
					<el-tooltip class="item" effect="dark" content="已支付且订单状态为已完成状态的订单，该金额不含服务费" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:calc(40px - 1px);display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							可提现金额（普通）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.normal_realavailablemoney}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.normal_availableordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>
				</div>

				<!-- 汇付天下提现金额 -->
				<div class="sys-wallet-msg-center-li" style="float:left;width:100%;height:40px;overflow:hidden;">
					
					<!-- 保障金 -->
					<el-tooltip class="item" effect="dark" content="已完成并提现的订单发起售后退款的金额" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:calc(40px - 1px);display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							预扣保障金（汇付）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.huifu_refundprices}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.huifu_refundordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>

					<!-- 冻结提现金额 -->
					<el-tooltip class="item" effect="dark" content="已支付但订单状态未达到已完成状态的订单（商家已取消的订单除外），该金额不含服务费" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:40px;display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							冻结提现金额（汇付）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.huifu_realfrozenmoney}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.huifu_frozenordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>

					<!-- 正在提现金额 -->
					<el-tooltip class="item" effect="dark" content="已提交提现申请，但平台尚未进行提现审核的订单，该金额不含手续费" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:40px;display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							正在提现金额（汇付）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.huifu_realwaitingmoney}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.huifu_waitingordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>

					<!-- 可提现金额 -->
					<el-tooltip class="item" effect="dark" content="已支付且订单状态为已完成状态的订单，该金额不含服务费" placement="top-start">
					<div class="sys-wallet-msg-center-li-infos" style="float:left;height:40px;display:flex;align-items:center;margin-right:2%;">
						<span class="sys-wallet-msg-center-li-infos-money" style="font-size:12px;line-height:23px;color:#666666;">
							可提现金额（汇付）：￥
							<i class="sys-money" style="font-style:normal;font-size:15px;line-height:23px;color:#F56C6C;font-weight:550;">{{walletstats.huifu_realavailablemoney}}</i>
							<i class="sys-orders" style="font-style:normal;font-size:12px;line-height:23px;color:#999999;">（共 {{walletstats.huifu_availableordernums}} 单）</i>
						</span>
					</div>
					</el-tooltip>
				</div>

			</div>
		</div>

		<!-- 按钮 -->
		<div class="sys-wallet-msg-right" style="float:left;display:flex;justify-content:left;width:calc(14% - 112px);height:80px;align-items:center;padding:0 20px 0 20px;">
			<el-button type="primary" size="small" round @click="getwalletstats">刷新数据</el-button>
			<el-button type="warning" size="small" round @click="getmoney('')">提现</el-button>
		</div>
		
		<!--
		<el-button type="warning" size="small" round @click="testwalletauto()" style="float:right;">手动测试提现</el-button>
		-->

	</div>

	<!-- 警告 -->
	<div class="sys-wallet-msg-warning" style="margin:-20px 0 0 20px;">
		<el-button type="warning" size="small" circle @click="checkwalletinfos" icon="el-icon-setting"></el-button>
	</div>

	<!-- 警告描述 -->
	<el-dialog title="提现金额说明" :visible.sync="checkwalletmsg" width="45%" top="10vh">
		<p class="sys-warning-msg-title" style="display:inline-block;width:100%;font-size:15px;line-height:23px;font-weight:550;">金额描述</p>
		<span class="sys-warning-msg-span" style="display:inline-block;width:100%;font-size:13px;line-height:23px;font-weight:500;">预扣保障金：已完成并提现的订单发起售后退款的金额</span>
		<span class="sys-warning-msg-span" style="display:inline-block;width:100%;font-size:13px;line-height:23px;font-weight:500;">冻结提现金额：已支付但订单状态未达到已完成状态的订单（商家已取消的订单除外），该金额不含服务费</span>
		<span class="sys-warning-msg-span" style="display:inline-block;width:100%;font-size:13px;line-height:23px;font-weight:500;">正在提现金额：已提交提现申请，但平台尚未进行提现审核的订单，该金额不含手续费</span>
		<span class="sys-warning-msg-span" style="display:inline-block;width:100%;font-size:13px;line-height:23px;font-weight:500;">可提现金额：已支付且订单状态为已完成状态的订单，该金额不含服务费</span>
		
		<p class="sys-warning-msg-title" style="display:inline-block;width:100%;font-size:15px;line-height:23px;font-weight:550;margin-top:50px">提现方式</p>
		<span class="sys-warning-msg-span" style="display:inline-block;width:100%;font-size:13px;line-height:23px;font-weight:500;">普通提现：提现统一打款至指定账号</span>
		<span class="sys-warning-msg-span" style="display:inline-block;width:100%;font-size:13px;line-height:23px;font-weight:500;">汇付天下提现：由汇付天下按订单支付进行分账打款（注：下单时支付方式为汇付天下的订单）</span>
	</el-dialog>


	<!--
	<div class="backborder1" v-loading="walletloading" style="margin-top:20px">
		<el-tooltip class="item" effect="dark" content="已完成并提现的订单发起售后退款的金额" placement="top-start">
		<div class="sys-wallet-main-totals">
			<span class="sys-wallet-main-totals-title">预扣保障金：￥</span>
			<i class="sys-wallet-main-totals-money">{{walletstats.refundprices}}</i>
			<i class="sys-wallet-main-totals-orders">（售后单共 {{walletstats.refundordernums}} 单）</i>
		</div>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="已支付但订单状态未达到已完成状态的订单（商家已取消的订单除外），该金额不含服务费" placement="top-start">
		<div class="sys-wallet-main-totals">
			<span class="sys-wallet-main-totals-title">冻结提现金额：￥</span>
			<i class="sys-wallet-main-totals-money">{{walletstats.realfrozenmoney}}</i>
			<i class="sys-wallet-main-totals-orders">（共 {{walletstats.frozenordernums}} 单）</i>
		</div>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="已提交提现申请，但平台尚未进行提现审核的订单，该金额不含手续费" placement="top-start">
		<div class="sys-wallet-main-totals">
			<span class="sys-wallet-main-totals-title">正在提现金额：￥</span>
			<i class="sys-wallet-main-totals-money">{{walletstats.realwaitingmoney}}</i>
			<i class="sys-wallet-main-totals-orders">（共 {{walletstats.waitingordernums}} 单）</i>
		</div>
		</el-tooltip>
		<el-tooltip class="item" effect="dark" content="已支付且订单状态为已完成状态的订单，该金额不含服务费" placement="top-start">
		<div class="sys-wallet-main-totals">
			<span class="sys-wallet-main-totals-title">可提现金额：￥</span>
			<i class="sys-wallet-main-totals-money">{{walletstats.realavailablemoney}}</i>
			<i class="sys-wallet-main-totals-orders">（共 {{walletstats.availableordernums}} 单）</i>
		</div>
		</el-tooltip>
		<el-button type="primary" size="small" round @click="getwalletstats">刷新数据</el-button>
		<el-button type="warning" size="small" round @click="getmoney('')">提现</el-button>
	</div>
	-->

	<div class="backborder2" style="margin-top:10px" v-loading="exportloading">
		<div class="sys-wallet-main-title">提现记录</div>
		<div>
			<el-form :inline="true" class="demo-form-inline" size="small">	
				<el-form-item style="width:25%">
					<el-date-picker	v-model="walletgetquery.date" type="daterange" style="width:100%"
						range-separator="至"
						start-placeholder="申请提现时间下限"
						end-placeholder="申请提现时间上限"
						value-format="yyyy-MM-dd" :unlink-panels="false" @change="walletgetquery.ischange=true">
					</el-date-picker>
				</el-form-item>
				<el-form-item style="width:12%">
					<el-select v-model="walletgetquery.status" @change="walletgetquery.ischange=true" clearable placeholder="请选择审核类型">
						<el-option v-for="(item,index) in walletstatuslists" :label="item.name" :value="item.id" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入提现流水号" v-model="walletgetquery.key" clearable @change="walletgetquery.ischange=true" style="width:100%" @keyup.enter.native="getwalletlogs"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" round @click="getwalletlogs">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-download" size="small" round @click="getExportall">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="walletloglists" border="1" v-loading="walletgetquery.loading" @selection-change="getselectids">
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column label="流水号"  align="center" width="170" fixed="left">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.paysn}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作人" align="center" width="120" fixed="left">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.username ? scope.row.username : '系统超时自动' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="申请时间" align="center" width="170" fixed="left">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.inputtime}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现账号" align="center" width="120">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.paytype}}</span><br/>
					<span class="sys-wallet-main-lists">{{scope.row.paytypevalue}}</span>
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center" width="120">
				<template slot-scope="scope">
					<div class="sys-wallet-main-lists" v-if="scope.row.status==1 || scope.row.status==4">待审核</div>
					<div class="sys-wallet-main-lists" v-if="scope.row.status==2">提现成功</div>
					<div class="sys-wallet-main-lists" v-if="scope.row.status==3">
						<span>提现失败</span>
						<el-tooltip class="item" effect="dark" :content="scope.row.reason" placement="top">
						<span style="padding:2px 4px;border-radius:50%;color:#fff;background:#e6a23c;">?</span>
						</el-tooltip>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="提现金额" align="center" width="120">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.realbalance}}</span>
				</template>
			</el-table-column>
			<!--
			<el-table-column label="结余提现金额" align="center" width="120">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.afterbalance}}</span>
				</template>
			</el-table-column>
			-->
			<el-table-column label="业务类型" align="center" width="120">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.type}}</span>
				</template>
			</el-table-column>
			<el-table-column label="完成 / 失败时间" align="center" width="170">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists" v-if="scope.row.status==1">-</span>
					<span class="sys-wallet-main-lists" v-if="scope.row.status==2">{{scope.row.finishtime}}</span>
					<span class="sys-wallet-main-lists" v-if="scope.row.status==3">{{scope.row.errortime}}</span>
				</template>
			</el-table-column>
			<!--
			<el-table-column label="支付流水单号" align="center" width="200">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.outsn}}</span>
				</template>
			</el-table-column>
			-->
			<el-table-column label="操作" align="center" fixed="right" width="220">
				<template slot-scope="scope">
					<el-button type="" size="small" round @click="getwalletorders(scope.row)">查看提现订单</el-button>
					<el-button type="" icon="el-icon-download" size="small" round  @click="getExportsingle(scope.row.id)" >导出</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
	        <!--分页begin-->
	        <el-pagination
		        @size-change="PageSizeChange"
		        @current-change="PageCurrentChange"
		        :current-page="walletgetquery.p"
		        :page-sizes="[10, 20, 50]"
		        :page-size="walletgetquery.rollpage"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="walletrows">
	        </el-pagination>
	        <!--分页end-->
	    </div>	
	</div>


	<!-- 提现操作 -->
	<el-dialog title="提现申请" :visible.sync="getmoneyquery.dialog" width="35%" top="10vh">
		<div class="wallet-sale-table" v-loading="getmoneyquery.loading">
			<table>
				<tr>
					<td class="mallettitle" colspan="3">提现账户</td>
					<td colspan="2">
						<el-select v-model="getmoneyquery.paytype" clearable remote  filterable size="small"  placeholder="请选择提现账户" style="width:100%" @change="changewalletpaytype(getmoneyquery.paytype)">
							<el-option v-for="(item,index) in paytypelists" :label="item.name" :value="item.id" :key="index"></el-option>
						</el-select>
						<a class="settingaccount" @click="getpaysettings">还没有提现账号 ？ 去设置</a>
					</td>	
				</tr>
				<tr>
					<td class="mallettitle" colspan="3" width="30%">提现金额</td>
					<td colspan="2" class="malletcontent">{{getmoneyquery.realbalance}}</td>	
				</tr>
				<tr v-if="getmoneyquery.refundprice < 0">
					<td class="mallettitle" colspan="3" width="30%">预扣保障金</td>
					<td colspan="2" class="malletcontent" style="color:#F56C6C">{{getmoneyquery.refundprice}}</td>	
				</tr>
				<tr v-if="getmoneyquery.lastbalance!=0">
					<td class="mallettitle" colspan="3" width="30%">剩余提现金额</td>
					<td colspan="2" class="malletcontent" :style="getmoneyquery.lastbalance > 0 ? '' : 'color:#F56C6C' ">{{getmoneyquery.lastbalance}}</td>	
				</tr>
			</table>
			<div class="wallet-sale-table-warning">注：提现预计1-2个工作日到账</div>
	    </div>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="getmoneyquery.dialog = false">取 消</el-button>			        
			<el-button size="small" type="primary" @click="submitgetmoney" :loading="getmoneyquery.loading">提 交</el-button>
		</div>
	</el-dialog>


	<!-- 设置提现账号 -->
	<el-dialog title="添加提现账号" :visible.sync="addpaysetting.dialog" width="25%" top="20vh">
		<div class="sys-wallet-get-account" v-loading="addpaysetting.loading">
			<div class="sys-wallet-get-warning">警告：填写的收款账号持有人名称要与宠赞供货商的法人名称一致，否则将审核不通过，导致打款失败</div>
			<el-form :inline="true" class="demo-form-inline" size="small">	
				<el-form-item label="支付类型" label-width="120">
					<el-select v-model="addpaysetting.type" filterable  placeholder="请选择提现账号类型">
						<el-option v-for="(item,index) in syspaytypelsits" :label="item.name" :value="item.id" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="支付账号" label-width="120">
					<el-input placeholder="请填写账号" v-model="addpaysetting.account" clearable />
				</el-form-item>
				<el-form-item label="真实姓名" label-width="120">
					<el-input placeholder="请填写真实姓名" v-model="addpaysetting.truename" clearable />
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="addpaysetting.dialog = false">取 消</el-button>			        
			<el-button size="small" type="primary" @click="submitpaytype">提 交</el-button>
		</div>
	</el-dialog>


	<!-- 提现订单详情 -->
	<el-dialog title="查看提现订单详情" :visible.sync="walletorderquery.dialog" width="60%" top="10vh">
		<el-table :data="walletorderlists" border="1" v-loading="walletorderquery.loading">
			<el-table-column label="订单号"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.ordernumber}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现金额（不含服务费）"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.realprices}}</span>
				</template>
			</el-table-column>
			<el-table-column label="支付时间"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.paytime}}</span>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
	        <!--分页begin-->
	        <el-pagination
		        @size-change="orderPageSizeChange"
		        @current-change="orderPageCurrentChange"
		        :current-page="walletorderquery.p"
		        :page-sizes="[10, 20, 50]"
		        :page-size="walletorderquery.rollpage"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="walletorderrows">
	        </el-pagination>
	        <!--分页end-->
	    </div>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="walletorderquery.dialog = false">取 消</el-button>			        
		</div>
	</el-dialog>


	<!-- 导出提现记录 -->
	<el-dialog title="导出提现记录" :visible.sync="exportDoalog" width="95%" top="10vh">
		<div class="dialog-footer" style="padding-bottom:30px;text-align:right;">
			<el-button type="primary" size="small" @click="exportwallet">导 出</el-button>	
			<el-button size="small" @click="exportDoalog = false">取 消</el-button>			        
		</div>
		<el-table :data="exportdata" border="1">
			<el-table-column label="提现流水单号"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.paysn}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现账号名称"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.paytypename}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现账号"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.paytypevalue}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现状态"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.status}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现申请时间"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.iputtime}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现失败原因"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.reason}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提现订单号"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.ordernumber}}</span>
				</template>
			</el-table-column>
			<el-table-column label="原始提现金额"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.totals}}</span>
				</template>
			</el-table-column>
			<el-table-column label="售后扣减金额"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.refunds}}</span>
				</template>
			</el-table-column>
			<el-table-column label="可提现金额"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.prices}}</span>
				</template>
			</el-table-column>
			<el-table-column label="服务费费率（%）"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.tax}}</span>
				</template>
			</el-table-column>
			<el-table-column label="服务费"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.taxprice}}</span>
				</template>
			</el-table-column>
			<el-table-column label="实际提现金额"  align="center">
				<template slot-scope="scope">
					<span class="sys-wallet-main-lists">{{scope.row.realprices}}</span>
				</template>
			</el-table-column>
		</el-table>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" size="small" @click="exportwallet">导 出</el-button>	
			<el-button size="small" @click="exportDoalog = false">取 消</el-button>			        
		</div>
	</el-dialog>



  </div>
  </transition>  
</template>

<script>

export default {
 
  data () {
    return {
        url:this.GLOBAL.domain+"wallet/index",
        transitionshow:true,
        actionauth:'', //功能权限
		lists:[{},{},{},{},{}],
		walletloading:false,
		walletstats:{},

		getmoneyquery: {
			act:'getwalletmoney',
			token:this.$cookies.get('token'),
			dialog:false,
			loading:false,
			paytype:'',
			balance:'',
			tax:'',
			taxbalance:'',
			realbalance:'',
			refundprice:'',
			lastbalance:'',
			paytype:'',
		},

		syspaytypelsits:[],
		paytypelists:[
			{id:1,name:'支付宝 + 13307717260'},
			{id:2,name:'支付宝 + 18077773838'},
			{id:3,name:'支付宝 + 18172334578'}
		],

		addpaysetting: {
			act:'addpaysetting',
			token:this.$cookies.get('token'),
			dialog:false,
			loading:false,
			type:'',
			account:'',
			truename:'',
		},

		walletgetquery: {
			act:'walletgetlog',
			token:this.$cookies.get('token'),
			loading:false,
			ischange:false,
			date:[],
			status:'',
			key:'',
			p:1,
			rollpage:10,
		},
		walletstatuslists:[{id:1,name:'待审核'},{id:2,name:'提现完成'},{id:3,name:'提现失败'}],
		walletloglists:[],
		walletrows:0,

		walletorderquery: {
			act:'walletgetorderlog',
			token:this.$cookies.get('token'),
			logid:'',
			loading:false,
			dialog:false,
			p:1,
			rollpage:10
		},
		walletorderlists:[],
		walletorderrows:0,

		checkwalletmsg:false,
		exportloading:false,
		exportDoalog:false,
		exportids:[],
		exportdata:[],
		exporthead:[],
		exportfield:[],
		exportlists:[],
		exportname:'',

    }
  },
    
  mounted(){  
    this.getactionauth();
	this.getwalletstats();   //获取钱包金额统计信息
	this.updatemypaytype();  //获取我的提现账号
	this.getwalletlogs();    //获取提现记录
  },
  
  methods:{

	  /** 导出提现记录数据-单个提现记录 **/
	  getExportsingle(id) {
		  let ids=[];
		  ids.push(id);
		  this.getexportwalletdata(ids);
	  },
	  
	  /** 导出提现记录数据-多选 **/
	  getExportall() {
		  //获取到导出的记录id信息
		  if(this.exportids.length==0) {this.$message.error('请选择要导出的记录');return false;}
		  this.getexportwalletdata(this.exportids);
	  },
	  

	  /** 获取导出记录数据 **/
	  getexportwalletdata(ids) {
		 this.exportdata=[];
		 this.exportloading=true;
		 var resource = this.$resource(this.GLOBAL.exportUrl+"wallet/index");
		 resource.save({act:'exportwalletdata',ids:ids.join(","),token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.exportloading=false;
			}else{
				this.exportdata=JSON.parse(Base64.decode(res.data.Data));
				this.exportloading=false;
				this.exportDoalog=true;
			}
		 }).catch((res) => {
			this.exportloading=false;
		 });
	  },


	  /** 获取表里选中的id **/
	  getselectids(val) {
		  let _this=this;
		  this.exportids=[];
		  val.forEach(function(item,i) {
			  _this.exportids.push(item.id);
		  });
	  },


	  /** 导出提现记录数据 **/
	  exportwallet() {    
		  this.exporthead=['提现流水订单号','提现账号名称','提现账号','提现状态','提现申请时间','提现失败原因','提现订单号','原始提现金额','售后扣减金额','可提现金额','服务费费率（%）','服务费','实际提现金额'];
		  this.exportfield=['paysn','paytypename','paytypevalue','status','iputtime','reason','ordernumber','totals','refunds','prices','tax','taxprice','realprices'];
		  this.exportlists=this.exportdata;
		  this.exportname='提现记录详情';
		  this.exportput();
		  this.exportDoalog=false;		
	  },

	  /** 确认导出信息 **/
	  exportput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var data = this.formatJson(this.exportfield, this.exportlists);
			  export_json_to_excel(this.exporthead, data, this.exportname);
		  })
	  },
		
	  //导出表格数据
	  formatJson(filterVal, jsonData) {
	　	  return jsonData.map(v => filterVal.map(j => v[j]));
	　},

	  ///////////////////////////////////////////////////////
	  ///////////////////////////////////////////////////////


	  /** 测试自动提现 **/
	  testwalletauto() {
		 var resource = this.$resource(this.url);
		 resource.save({act:'checkwalletauto',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.getwalletlogs();
			}
		 }).catch((res) => {
			
		 });
	  },


	 /** 查看提现订单 **/ 
	 getwalletorders(item) {
		 this.walletorderquery.logid=item.id;
		 this.walletorderquery.dialog=true;
		 this.walletorderquery.ordernums=0;
		 this.walletorderquery.p=1;
		 this.walletorderquery.rollpage=10;
		 this.walletorderlists=[];
		 this.walletorderrows=0;
		 this.getwalletorderdatas();
	 },

	 /** 获取平台订单数据列表 **/
	 getwalletorderdatas() {
		 this.walletorderquery.loading=true;
		 var resource = this.$resource(this.url);
		 resource.save(this.walletorderquery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.walletorderquery.loading=false;
			}else{
				this.walletorderlists=JSON.parse(Base64.decode(res.data.Data));
				this.walletorderrows=parseInt(res.data.count);
				this.walletorderquery.loading=false;
			}
		 }).catch((res) => {
			this.walletorderquery.loading=false;
		 });
	 },
	 orderPageSizeChange(val) {
        this.walletorderquery.rollpage = val;
        this.getwalletorderdatas();
    },
    orderPageCurrentChange(val) {
        this.walletorderquery.p = val;
        this.getwalletorderdatas();
    }, 


	 /** 保存提现申请记录 **/
	 submitgetmoney() {
		this.getmoneyquery.loading=true;
		var resource = this.$resource(this.url);
		resource.save(this.getmoneyquery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login');
				console.log(' =====>', res.data.Message);
				// this.$message.error(res.data.Message);
				this.$alert(res.data.Message, '提现错误', {
					confirmButtonText: '确定',
				});
				this.getmoneyquery.loading=false;
			}else{
				this.getmoneyquery.loading=false;
				this.getmoneyquery.dialog=false;
				this.getwalletstats(); //刷新钱包金额统计信息
				this.getwalletlogs();  //刷新提现记录
			}
		}).catch((res) => {
			this.getmoneyquery.loading=false;
		});
	 },



	 /** 获取提现记录 **/
	 getwalletlogs() {
		 if(this.walletgetquery.ischange) {
			 this.walletgetquery.p=1;
			 this.walletgetquery.rollpage=10;
		 }

		 this.walletgetquery.loading=true;
		 var resource = this.$resource(this.url);
		 resource.save(this.walletgetquery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.walletgetquery.loading=false;
			}else{
				this.walletloglists=JSON.parse(Base64.decode(res.data.Data));
				this.walletrows=parseInt(res.data.count);
				if(this.walletgetquery.ischange) this.walletgetquery.ischange=false;
				this.walletgetquery.loading=false;
			}
		 }).catch((res) => {
			this.walletgetquery.loading=false;
		 });

	 },
	 PageSizeChange(val) {
        this.walletgetquery.rollpage = val;
        this.getwalletlogs();
    },
    PageCurrentChange(val) {
        this.walletgetquery.p = val;
        this.getwalletlogs();
    }, 


	 /** 获取我的提现账号 **/
	 updatemypaytype() {
		 var resource = this.$resource(this.url);
		 resource.save({act:'getmypaytypelists',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.paytypelists=JSON.parse(Base64.decode(res.data.Data));
			}
		 }).catch((res) => {
			
		 });
	 },


	/** 新增支付账号 **/
	submitpaytype() {
		this.addpaysetting.loading=true;
		var resource = this.$resource(this.url);
		resource.save(this.addpaysetting).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.addpaysetting.loading=false;
			}else{
				this.addpaysetting.loading=false;
				this.addpaysetting.dialog=false;
				this.updatemypaytype(); //更新我的支付账号
			}
		}).catch((res) => {
			this.addpaysetting.loading=false;
		});
	},


	/** 获取系统提现方式 **/
	getsysaccountlsits() {
		var resource = this.$resource(this.url);
		resource.save({act:'getsyspaytypelists',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.syspaytypelsits=JSON.parse(Base64.decode(res.data.Data));
			}
		}).catch((res) => {
			
		});
	},


	/** 获取提现账号信息列表 **/  
	getpaysettings() {
		this.addpaysetting.dialog=true;
		this.addpaysetting.type='';
		this.addpaysetting.account='';
		this.addpaysetting.truename='';
		//获取系统提现金额方式
		this.getsysaccountlsits();
	},


	/** 获取钱包金额统计信息 **/
	getwalletstats() {
		this.walletloading=true;
		var resource = this.$resource(this.url);
		resource.save({act:'getwalletstats',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.walletloading=false;
			}else{
				this.walletstats=JSON.parse(Base64.decode(res.data.Data));
				this.walletloading=false;
			}
		}).catch((res) => {
			this.walletloading=false;
		});
	},

    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },


	/** 切换提现方式 **/
	changewalletpaytype(type) {
		this.getmoney(type);
	},

	/** 金额提现 **/
	getmoney(paytype) {
		this.getmoneyquery.dialog=true;
		this.getmoneyquery.balance='';
		this.getmoneyquery.tax='';
		this.getmoneyquery.taxbalance='';
		this.getmoneyquery.realbalance='';
		this.getmoneyquery.paytype=paytype || paytype!='' ? paytype : '';

		this.getmoneyquery.loading=true;
		var resource = this.$resource(this.url);
		resource.save({act:'getwalletgetbalance',paytype:paytype || paytype!='' ? paytype : '',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.getmoneyquery.loading=false;
			}else{
				var result=JSON.parse(Base64.decode(res.data.Data));
				this.getmoneyquery.balance=result.balance;
				this.getmoneyquery.tax=result.tax;
				this.getmoneyquery.taxbalance=result.taxbalance;
				this.getmoneyquery.realbalance=result.realbalance;
				this.getmoneyquery.refundprice=result.refundprice;
				this.getmoneyquery.lastbalance=result.lastbalance;
				this.getmoneyquery.loading=false;

				

			}
		}).catch((res) => {
			this.getmoneyquery.loading=false;
		});
	},


	//查看备注信息描述
	checkwalletinfos() {
		this.checkwalletmsg=true;
	}
    

  } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.sys-wallet-main {display:inline-block;border:1px solid #dddddd;border-radius:6px;box-shadow:5px 5px 10px #999999;margin:10px 3% 20px 0;background:rgba(221,221,221,.3)}
.sys-wallet-main-money {display:inline-block;width:100%;text-align:center;font-size:21px;font-weight:500;padding:10px 2% 0 0}
.sys-wallet-main-desc {display:inline-block;width:100%;text-align:center;font-size:13px;font-weight:500;padding:0 2% 10px 0;color:#666666}
.sys-wallet-main-title {display:inline-block;width:100%;font-size:16px;font-weight:550;padding:20px 0;color:#999999}
.sys-wallet-main-lists {font-size:13px}
.sys-wallet-main-totals {display:inline-block;margin:0 2% 10px 0}
.sys-wallet-main-totals-title {display:inline-block;font-size:13px;font-weight:500;color:#666666}
.sys-wallet-main-totals .sys-wallet-main-totals-money {display:inline-block;color:#F56C6C;font-size:15px;font-weight:550;font-style:normal}
.sys-wallet-main-totals .sys-wallet-main-totals-orders {display:inline-block;font-size:12px;font-weight:500;color:#999999;font-style:normal}

.wallet-sale-table {padding:1% 1% 1% 1% !important;}
.wallet-sale-table table {width:100%;border-radius:5px;border-collapse:collapse;border-spacing:0;border-left:1px solid rgb(221,221,221,.6);border-top:1px solid rgb(221,221,221,.6);margin-top:10px}
.wallet-sale-table table td {border-right:1px solid rgb(221,221,221,.6);border-bottom:1px solid rgb(221,221,221,.6);font-size:13px;padding:10px 15px;color:#606266;}
.wallet-sale-table table .mallettitle {background:rgb(221,221,221,.3);font-weight:500}
.wallet-sale-table table .settingaccount {font-size:13px;color:#666666;margin-left:2%;text-decoration:underline;cursor:pointer;width:100%;display:inline-block;margin-top:5px}
.wallet-sale-table table .malletcontent {font-size:15px;font-weight:550;}
.wallet-sale-table table .minus {color:#F56C6C}
.wallet-sale-table table .handle {font-size:13px;color:#999999;font-style:normal;font-weight:400}
.wallet-sale-table-warning {font-size:13px;font-weight:500;color:#F56C6C;padding:10px 0}

.sys-wallet-get-account {display:inline-block;width:100%}
.sys-wallet-get-warning {display:inline-block;width:90%;font-size:13px;line-height:23px;color:#F56C6C;background:#dddddd;padding:5px 5%;border-radius:6px;margin-bottom:20px}
</style>
<style>
.el-message-box__message p {
	overflow-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/mall/mallwallet.vue